<template>
    <div class="modal-backdrop-reminder">
        <div class="modal">
            <header class="modal-header">
                <slot name="header">
                    <h2>{{translate("reset_password")}}</h2>

                    <button type="button"
                            class="btn-close"
                            @click="close"> x
                    </button>
                </slot>
            </header>
            <div class="modal-body">
                <slot name="body">
                    <div class="reminder-msg">{{translate("email_to_reset_password")}}
                    </div>
                    <label>
                        <input v-model="value"
                               name="cad"
                               type="text"/>
                    </label>
                </slot>
            </div>
            <footer class="modal-footer">
                <slot name="footer">
                    <div class="navi-btns-modal">
                        <button @click.prevent="tryReset" class="remind-btn"> {{translate("send")}}</button>
                    </div>
                </slot>
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: "modalReminder",
        data() {
            return {
                value: ''
            }
        },
        methods: {

            tryReset() {
                let form = new FormData();
                form.append('email', this.value);
                let locale = this.$store.state.activeLang.id;
                form.append('locale', locale);

                this.$apiController.postRequestPasswordReset(form)
                    .then((res) => {
                        if (res.status === 'success') {
                            this.$router.push({name: 'reset_password', params: {email: this.value}});
                            this.$notifications.add('notification', this.translate('success_reset_password'), this.translate('send_reset_password_link_on_email'));
                            this.$emit('close');
                        } else {
                            this.$notifications.add('warning', this.translate('warning_reset_password'), this.translate(Array.isArray(res.message)?res.message.join(", "):res.message));
                            this.$emit('close');
                        }
                        this.value = '';
                    });
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            close() {
                this.$emit('close');
            },
        },
    }
</script>